import {enumerable} from './utilities.service';
import * as moment from "moment/moment";

export class PracticeChangeForm {
  completed: string;
  areaOfUse = 1;

  constructor(...args) {}

  fromObject(inputs: any = {}) {
    Object.keys(inputs)
      .map(k => {
        if (inputs.hasOwnProperty(k)) {
          try {
            this[k] = inputs[k];
          } catch (e) { }
        }
      });
  }

  asObject() {
    const o = {};
    Object.keys(this)
      .concat(Object.keys(this.constructor.prototype))
      .map(k => {
        return o[k] = this[k];
      });
    return o;
  }

  forReporting() {
    return {
      completed: moment(this.completed, 'X').format('DD/MM/YYYY'),
      areaOfUse: this.areaOfUse
    };
  }
}

export class PracticeChangeFormFertiliser extends PracticeChangeForm {
  preInput = 0;

  @enumerable(true)
  get preUse() {
    return this.preInput * this.areaOfUse;
  }
  postInput = 0;
  @enumerable(true)
  get postUse() {
    return this.postInput * this.areaOfUse;
  }
  @enumerable(true)
  get reductionAmount() {
    return this.preUse - this.postUse;
  }
  postProductivityImprove = 0;
  postInputChange = 0;

  constructor() {
    super(...arguments);
  }

  forReporting() {
    return {
      ...super.forReporting(),
      preInput: this.preInput,
      preUse: this.preUse,
      postInput: this.postInput,
      postUse: this.postUse,
      reductionAmount: this.reductionAmount,
      postProductivityImprove: this.postProductivityImprove,
      postInputChange: this.postInputChange,
    };
  }
}

export class PracticeChangeFormPesticide extends PracticeChangeForm {
  preInput = {
    l: 0, // l/ha
    g: 0, // g/l/ha
    kg: 0 // kg/ha
  };
  @enumerable(true)
  get preUse() {
    // =SUM((O4*R4)+(P4*R4)+(Q4*R4))
    return (this.preInput.l * this.areaOfUse) + (this.preInput.g * this.areaOfUse) + (this.preInput.kg * this.areaOfUse);
  }
  postInput = {
    l: 0, // l/ha
    g: 0, // g/l/ha
    kg: 0 // kg/ha
  };
  @enumerable(true)
  get postUse() {
    return (this.postInput.l * this.areaOfUse) + (this.postInput.g * this.areaOfUse) + (this.postInput.kg * this.areaOfUse);
  }
  @enumerable(true)
  get reductionAmount() {
    return this.preUse - this.postUse;
  }
  postProductivityImprove = 0;
  postInputChange = 0;

  constructor() {
    super(...arguments);
  }

  forReporting() {
    return {
      ...super.forReporting(),
      preInputL: this.preInput.l,
      preInputG: this.preInput.g,
      preInputKg: this.preInput.kg,
      preUse: this.preUse,
      postInputL: this.postInput.l,
      postInputG: this.postInput.g,
      postInputKg: this.postInput.kg,
      postUse: this.postUse,
      reductionAmount: this.reductionAmount,
      postProductivityImprove: this.postProductivityImprove,
      postInputChange: this.postInputChange,
    };
  }
}

export class PracticeChangeFormWater extends PracticeChangeForm {
  preInput = 0;
  @enumerable(true)
  get preUse() {
    return this.preInput * this.areaOfUse;
  }
  postInput = 0;
  @enumerable(true)
  get postUse() {
    return this.postInput * this.areaOfUse;
  }
  @enumerable(true)
  get reductionAmount() {
    return this.preUse - this.postUse;
  }
  postProductivityImprove = 0;
  postInputChange = 0;

  constructor() {
    super(...arguments);
  }

  forReporting() {
    return {
      ...super.forReporting(),
      preInput: this.preInput,
      preUse: this.preUse,
      postInput: this.postInput,
      postUse: this.postUse,
      reductionAmount: this.reductionAmount,
      postProductivityImprove: this.postProductivityImprove,
      postInputChange: this.postInputChange,
    };
  }
}

export class PracticeChangeFormSoil extends PracticeChangeForm {
  prePercentageBare = 0.2;
  @enumerable(true)
  get preSedimentMovement() {
    // =IF(F5="","",(F5*(G5/100)*33+F5*(1-G5/100)*33*0.2)/F5)
    return (this.areaOfUse * this.prePercentageBare * 33 + this.areaOfUse * (1 - this.prePercentageBare) * 33 * 0.2) / this.areaOfUse;
  }
  @enumerable(true)
  get preNitrogenMovement() {
    // =IF(F5="","",(F5*(G5/100)*15+F5*(1-G5/100)*15*0.2)/F5)
    return (this.areaOfUse * this.prePercentageBare * 15 + this.areaOfUse * (1 - this.prePercentageBare) * 15 * 0.2) / this.areaOfUse;
  }
  @enumerable(true)
  get prePhosphorusMovement() {
    // =IF(F5="","",(F5*(G5/100)*2+F5*(1-G5/100)*2*0.2)/F5)
    return (this.areaOfUse * this.prePercentageBare * 2 + this.areaOfUse * (1 - this.prePercentageBare) * 2 * 0.2) / this.areaOfUse;
  }
  postPercentageBare = 0.2;
  @enumerable(true)
  get postSedimentMovement() {
    // =IF(F5="","",(F5*(G5/100)*33+F5*(1-G5/100)*33*0.2)/F5)
    return (this.areaOfUse * this.postPercentageBare * 33 + this.areaOfUse * (1 - this.postPercentageBare) * 33 * 0.2) / this.areaOfUse;
  }
  @enumerable(true)
  get postNitrogenMovement() {
    // =IF(F5="","",(F5*(G5/100)*15+F5*(1-G5/100)*15*0.2)/F5)
    return (this.areaOfUse * this.postPercentageBare * 15 + this.areaOfUse * (1 - this.postPercentageBare) * 15 * 0.2) / this.areaOfUse;
  }
  @enumerable(true)
  get postPhosphorusMovement() {
    // =IF(F5="","",(F5*(G5/100)*2+F5*(1-G5/100)*2*0.2)/F5)
    return (this.areaOfUse * this.postPercentageBare * 2 + this.areaOfUse * (1 - this.postPercentageBare) * 2 * 0.2) / this.areaOfUse;
  }
  @enumerable(true)
  get changeSedimentMovement() {
    return this.preSedimentMovement - this.postSedimentMovement; // TODO: this.areaOfUse ? SS says / area - but, header is per ha/ Is this total? If so should be * total
  }
  @enumerable(true)
  get changeNitrogenMovement() {
    return this.preNitrogenMovement - this.postNitrogenMovement; // TODO: this.areaOfUse ? SS says / area - but, header is per ha/ Is this total? If so should be * total
  }
  @enumerable(true)
  get changePhosphorusMovement() {
    return this.prePhosphorusMovement - this.postPhosphorusMovement; // TODO: this.areaOfUse ? SS says / area - but, header is per ha/ Is this total? If so should be * total
  }

  likelihood = 1;
  years = 1;
  @enumerable(true)
  get adjustmentSedimentMovement() {
    // =IF(F5<=0,"",O5*R5*S5/F5)
    return this.changeSedimentMovement * this.likelihood * this.years / this.areaOfUse; // TODO: postSedimentMovement ?
  }
  @enumerable(true)
  get adjustmentNitrogenMovement() {
    // =IF(F5<=0,"",O5*R5*S5/F5)
    return this.changeNitrogenMovement * this.likelihood * this.years / this.areaOfUse; // TODO: postNitrogenMovement ?
  }
  @enumerable(true)
  get adjustmentPhosphorusMovement() {
    // =IF(F5<=0,"",O5*R5*S5/F5)
    return this.changePhosphorusMovement * this.likelihood * this.years / this.areaOfUse; // TODO: postPhosphorusMovement ?
  }

  constructor() {
    super(...arguments);
  }

  forReporting() {
    return {
      ...super.forReporting(),
      prePercentageBare: this.prePercentageBare,
      preSedimentMovement: this.preSedimentMovement,
      preNitrogenMovement: this.preNitrogenMovement,
      prePhosphorusMovement: this.prePhosphorusMovement,
      postPercentageBare: this.postPercentageBare,
      postSedimentMovement: this.postSedimentMovement,
      postNitrogenMovement: this.postNitrogenMovement,
      postPhosphorusMovement: this.postPhosphorusMovement,
      changeSedimentMovement: this.changeSedimentMovement,
      changeNitrogenMovement: this.changeNitrogenMovement,
      changePhosphorusMovement: this.changePhosphorusMovement,
      likelihood: this.likelihood,
      years: this.years,
      adjustmentSedimentMovement: this.adjustmentSedimentMovement,
      adjustmentNitrogenMovement: this.adjustmentNitrogenMovement,
      adjustmentPhosphorusMovement: this.adjustmentPhosphorusMovement
    };
  }
}
